export const countries: string[] = [
  "Adelie Land (France)",
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "Americas",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Argentinian Antarctic Territory",
  "Armenia",
  "Aruba",
  "Australia",
  "Australia (includes External Territories)",
  "Australian Antarctic Territory",
  "Australian External Territories, nec",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Antarctic Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cabo Verde",
  "Caribbean",
  "Cayman Islands",
  "Central African Republic",
  "Central America",
  "Central and West Africa",
  "Central Asia",
  "Chad",
  "Chile",
  "Chilean Antarctic Territory",
  "China (excludes SARs and Taiwan)",
  "Chinese Asia (includes Mongolia)",
  "Colombia",
  "Comoros",
  "Congo, Democratic Republic of",
  "Congo, Republic of",
  "Cook Islands",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Eastern Europe",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "England",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Faroe Islands",
  "Falkland Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia",
  "Gaza Strip and West Bank",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hong Kong (SAR of China)",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Japan and the Koreas",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of (North)",
  "Korea, Republic of (South)",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau (SAR of China)",
  "Madagascar",
  "Mainland South-East Asia",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Maritime South-East Asia",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Melanesia",
  "Mexico",
  "Micronesia",
  "Micronesia, Federated States of",
  "Middle East",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "North Africa",
  "North Africa and the Middle East",
  "North Macedonia",
  "North-East Asia",
  "North-West Europe",
  "Northern America",
  "Northern Europe",
  "Northern Ireland",
  "Northern Mariana Islands",
  "Norway",
  "Oceania and Antarctica",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn Islands",
  "Poland",
  "Polynesia (excludes Hawaii)",
  "Polynesia (excludes Hawaii), nec",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Queen Maud Land (Norway)",
  "Reunion",
  "Romania",
  "Ross Dependency (New Zealand)",
  "Russian Federation",
  "Rwanda",
  "Sint Maarten (Dutch part)",
  "St Barthelemy",
  "St Helena",
  "St Kitts and Nevis",
  "St Lucia",
  "St Martin (French part)",
  "St Pierre and Miquelon",
  "St Vincent and the Grenadines",
  "Samoa",
  "Samoa American",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Scotland",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South America",
  "South America, nec",
  "South-East Asia",
  "South Eastern Europe",
  "South Sudan",
  "Southern and Central Asia",
  "Southern and East Africa",
  "Southern and East Africa, nec",
  "Southern and Eastern Europe",
  "Southern Asia",
  "Southern Europe",
  "Spain",
  "Spanish North Africa",
  "Sri Lanka",
  "Sub-Saharan Africa",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom, Channel Islands and Isle of Man",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Islands, British",
  "Virgin Islands, United States",
  "Wales",
  "Wallis and Futuna",
  "Western Europe",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Unknown",
];
